import { Pipe, PipeTransform } from '@angular/core';
import { IPayload } from 'src/app/models/facility';


@Pipe({
  name: 'facilityfordropdown'
})
export class FacilityfordropdownPipe implements PipeTransform {

  transform(value: IPayload, ...args: any[]): string {
    let result = '';
    result += value.type === 'Unknown' || value.type === undefined ? '' : value.type + ' - ',
      result += [
        value.city === 'Unknown' ? false : value.city,
        value.state === 'Unknown' ? false : value.state,
        value.country === 'Unknown' ? false : value.country
      ].filter(Boolean).join(', ');
    return result;
  }


}
